const MathUtils = {
  /**
    @function convolv   
    @param array 2
    @returns convolution of two arrays.
    @description Takes parameter as two arrays and returns its convolution array.
    */
  convolve(xArr: number[], yArr: number[]) {
    const resultArray = [];
    const nLength = xArr.length;
    const mLength = yArr.length;

    for (let i = 0, j = 0; i < mLength; i++) {
      let result = 0;
      for (let k = 0; k < nLength; k++) {
        j = i - k;
        if (j >= 0 && j < mLength && typeof xArr[k] !== 'undefined' && typeof yArr[j] !== 'undefined')
          result += (xArr[k] as number) * (yArr[j] as number);
        else break;
      }
      resultArray[i] = result;
    }

    return resultArray;
  },

  /**
    @function asinh 
    @param arg
    @returns asinh(arg)
    @description Returns the inverse hyperbolic sine of the number
    */
  asinh(arg: number) {
    return Math.log(arg + Math.sqrt(arg * arg + 1));
  },

  /**
    @function aCosh
    @param arg {int} the number you want acosh(value)
    @returns inverse hyperbolic cosine number
    @description this function calculates the inverse hyperbolic cosine number
    */
  aCosh(arg: number) {
    return Math.log(arg + Math.sqrt(arg * arg - 1));
  },

  /**
    @function sinh
    @param  number
    @returns sinh(number)
    @description  This function takes as a parameter as anumber and returns hyperbolic sine of the number
    */
  sinh(number: number) {
    const x = number;
    const expNumber = Math.exp(x);
    const expNegNumber = Math.exp(-x);

    const sinhNumber = (expNumber - expNegNumber) / 2;

    return sinhNumber;
  },

  /**
    @function cosh
    @param  number
    @returns cosh(number)
    @description  This function takes as a parameter as anumber and returns hyperbolic cos of the number
    */
  cosh(number: number) {
    const x = number;
    const expNumber = Math.exp(x);
    const expNegNumber = Math.exp(-x);

    const coshNumber = (expNumber + expNegNumber) / 2;

    return coshNumber;
  },

  /**
    @function logBaseTen
    @param your_log{int} the number you want to get the log base of 10 from.
    @returns log base ten of number.
    @description Takes in a number and gets the log base of ten.
    */
  logBaseTen(your_log: number) {
    const result = Math.log(your_log) / Math.log(10);

    return result;
  },

  /**
    @function getLogMidPoint
    */
  getLogMidPoint(maxVal: number, minVal: number) {
    const avg = (this.logBaseTen(maxVal) + this.logBaseTen(minVal)) / 2;
    const val = Math.pow(10, avg);

    return val;
  },
};
export default MathUtils;
